var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$root.selectedShopCount > 0
    ? _c("div", [
        _c("div", { staticClass: "fixedSelectionList pcOnly" }, [
          _c("div", { staticClass: "fixedSelectionList__text" }, [
            _vm._v("問い合わせリストに追加した"),
            _c("span", { staticClass: "count" }, [
              _vm._v(_vm._s(_vm.$root.selectedShopCount)),
            ]),
            _vm._v("件に"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fixedSelectionList__button" },
            [
              _c(
                "marunage-button",
                {
                  attrs: {
                    "button-class": "orange",
                    bulk: true,
                    "form-name-prefix": "pc_marunage_button_",
                  },
                },
                [
                  _c("i", { staticClass: "heart outline icon" }),
                  _vm._v("まとめて問い合わせ"),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "fixedSelectionList__button" }, [
            _c(
              "button",
              {
                staticClass: "ui button basic orange",
                on: {
                  click: function ($event) {
                    _vm.location.href = "/checklist"
                  },
                },
              },
              [_vm._v("問い合わせリスト確認")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "fixedSelectionList spOnly" }, [
          _c("div", { staticClass: "fixedSelectionList__text" }, [
            _vm._v("問い合わせリスト"),
            _c("span", { staticClass: "count" }, [
              _vm._v(_vm._s(_vm.$root.selectedShopCount)),
            ]),
            _vm._v("件"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fixedSelectionList__button" },
            [
              _c(
                "marunage-button",
                {
                  attrs: {
                    "button-class": "orange",
                    bulk: true,
                    "form-name-prefix": "sp_marunage_button_",
                  },
                },
                [_vm._v("まとめて問合せ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(0),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "fixedSelectionList__button" }, [
      _c("a", { attrs: { href: "/checklist" } }, [_vm._v("リスト確認")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }